import { useState, useEffect } from 'react'

export default function useWindow() {
  const [[scrollTop, viewportHeight], setWindow] = useState([null, null])

  useEffect(() => {
    const handleWindow = () =>
      setWindow([document.documentElement.scrollTop, window.innerHeight])

    window.addEventListener('scroll', handleWindow)
    window.addEventListener('resize', handleWindow)
    return () => {
      window.removeEventListener('scroll', handleWindow)
      window.removeEventListener('resize', handleWindow)
    }
  })

  return [scrollTop, viewportHeight]
}
